import React from 'react';
import { Icon } from '../../_components';

export function ResultSection({ icon, label, isOpen, onToggle }) {
  const handleToggle = () => {
    if (onToggle) onToggle(label);
  };

  return (
    <div className="chronos-global-search-result-section">
      <div className="chronos-result-section-icon">
        {icon && <Icon icon={icon} />}
        {!icon && <Icon icon="far fa-fw" />}
      </div>
      <div className="chronos-result-section-label">{label}</div>
      <div className="chronos-result-section-toggle" onClick={handleToggle}>
        <Icon
          icon={
            isOpen ? 'far fa-chevron-down fa-fw' : 'far fa-chevron-up fa-fw'
          }
        />
      </div>
    </div>
  );
}
